module.exports = __webpack_public_path__ + "static/hybrid_icon-c5c5df1c48f25e514c8b2dda05a3a53a.svg";